import React from "react";
import {
  EMPTY_ARRAY_LENGTH,
  inboxReduxConstants,
} from "../../../constants";
import CustomerSurveyComponent from "./customerSurveyComponent";
import { renderBootStrapSpinner } from "./bootstrapSpinner";
import OrderDetailField from "./orderDetailField";

const OrderDetailsComponent = ({
  spinner,
  orderDetails,
  customerPreviewSurvey,
}) => {

  const sortQuestionsByQuestionOrder = (questions) => {
    return questions.sort((a, b) => a.questionOrder - b.questionOrder);
  };

  const renderCustomerSurvey = () => {
    if (spinner(inboxReduxConstants.GET_PREVIEW_CUSTOMER_SURVEY)) {
      return renderBootStrapSpinner();
    }
    if (customerPreviewSurvey.responseJson?.length) {
      return (
        <CustomerSurveyComponent
          responseJson={sortQuestionsByQuestionOrder(customerPreviewSurvey.responseJson)}
        />
      );
    }
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        No data found!
      </div>
    );
  };

  return (
    <div className="d-flex align-items-start border border-1 rounded-3 customer-survey-details m-3 overflow-y-auto custome-sidebar">
      <div className="rounded-start-3 d-flex align-items-start justify-content-center bg-secondary bg-opacity-10 border-end border-end-1 conversation-order-details custome-sidebar">
        <div className="order-details">
          {spinner(inboxReduxConstants.GET_CONVERSATION_ORDER_DETAILS) ? (
            renderBootStrapSpinner()
          ) : (
            <>
              <OrderDetailField
                label="Location:"
                value={orderDetails?.storeName}
              />
              <OrderDetailField
                label="Order Type:"
                value={orderDetails?.orderType}
              />
              <OrderDetailField
                label="Date & Time of Order:"
                value={orderDetails?.orderPlacedAt}
              />
              <OrderDetailField label="Item Ordered:" labelClassName="mb-1">
                {orderDetails?.itemsOrdered?.length >
                EMPTY_ARRAY_LENGTH ? (
                  orderDetails?.itemsOrdered.map((item) => (
                    <div
                      key={item.name}
                      className="d-flex justify-content-between align-items-center text-secondary fw-medium"
                    >
                      <p className="mb-1 pe-1">{item.name}</p>
                      <p className="mb-1">{item.quantity}</p>
                    </div>
                  ))
                ) : (
                  <div className="d-flex align-items-center justify-content-center">
                    No items found!
                  </div>
                )}
              </OrderDetailField>
            </>
          )}
        </div>
      </div>
      <div className="px-2 rounded-end-3 submitted-survey-container custome-sidebar">
        {renderCustomerSurvey()}
      </div>
    </div>
  );
};

export default OrderDetailsComponent;
